import { message } from 'ant-design-vue/es'
// import defaultSettings from '../defaultSettings';
import themeColor from './themeColor.js'

// let lessNodesAppended

const colorList = [
  {
    key: 'Dawn',
    color: '#F5222D'
  },
  {
    key: 'Volcano',
    color: '#FA541C'
  },
  {
    key: 'Sunset',
    color: '#FAAD14'
  },
  {
    key: 'Cyan',
    color: '#13C2C2'
  },
  {
    key: 'Aurora Green',
    color: '#52C41A'
  },
  {
    key: 'Daybreak Blue (Default)',
    color: '#52C41A'
  },
  {
    key: 'Geek Blue',
    color: '#2F54EB'
  },
  {
    key: 'Purple',
    color: '#722ED1'
  }
]

const updateTheme = (newPrimaryColor) => {
  const hideMessage = message.loading('Switching topics!', 0)
  try {
    themeColor.changeColor(newPrimaryColor).finally((t) => {
      setTimeout(() => {
        hideMessage()
      })
    })
  } catch (error) {
    setTimeout(() => {
      hideMessage()
    }, 100)
  }
}


const updateColorWeak = (colorWeak) => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  colorWeak ? document.body.classList.add('colorWeak') : document.body.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }
